<template>
  <div class="acseries-and-footer">
    <acserieseng></acserieseng>
    <scfootereng></scfootereng>
  </div>
</template>

<script>
 export default {
   name: 'accosmeticseng',
   components: {
     acserieseng: () => import('../components/ACseriesEng.vue'),
     scfootereng: () => import('../components/scFooterEng.vue')
   },
 }
</script>

<style lang="scss" scoped>
 $page-width: 960px;

 .acseries-and-footer {
   margin-top: 80px;
 }

 @media (max-width: 600px) {
   .acseries-and-footer {
     margin-top: 20px;
   }
 }
</style>
